<!--
 * @Author: wuhao
 * @Date: 2020-03-31 13:40:23
 * @LastEditors: wuhao
 * @LastEditTime: 2021-08-24 18:03:40
 * @Description: 封装table搜索条件
 -->

<template>
  <div class="apex-filter" :class="className">
    <div class="btn-divider" />
    <el-form ref="queryForm" :inline="true" :model="searchQuery" :size="getSize()" :label-width="labelWidth" @submit.native.prevent>
      <div ref="formContainer" class="form-container">
        <el-form-item
          v-for="(item, index) in getConfigList()"
          :key="index"
          :ref="item.value"
          :prop="item.value"
          :label="item.label"
          :label-width="item.labelWidth"
          :class="item.className"
        >
          <!-- 输入框 -->
          <el-input
            v-if="item.type === 'input'"
            v-model="searchQuery[item.value]"
            :class="`filter-${item.type}`"
            :type="item.type"
            :disabled="item.disabled"
            :clearable="item.clearable === false ? item.clearable : true"
            :placeholder="getPlaceholder(item)"
            v-bind="item.options"
            @keyup.enter.native="item.enter === false ? '' : search()"
          />
          <!-- 混合型输入框 -->
          <el-input
            v-if="item.type === 'mixin'"
            v-model="searchQuery[item.value]"
            :class="`filter-${item.type}`"
            :type="item.type"
            :disabled="item.disabled"
            :clearable="item.clearable === false ? item.clearable : true"
            :placeholder="getPlaceholder(item)"
            @keyup.enter.native="item.enter === false ? '' : search()"
          >
            <el-select
              slot="prepend"
              v-model="searchQuery[item.selectValue]"
              :clearable="item.selectClearable === false ? item.selectClearable : true"
              :placeholder="t('select.placeholder')"
              @change="handleEvent(item.emit, searchQuery[item.selectValue])"
            >
              <el-option
                v-for="(childItem, childIndex) in listTypeInfoFn(item)"
                :key="childIndex"
                :label="childItem.key"
                :value="childItem.value"
              />
            </el-select>
          </el-input>
          <!-- 选择框 -->
          <el-select
            v-if="item.type === 'select'"
            v-model="searchQuery[item.value]"
            :class="`filter-${item.type}`"
            :disabled="item.disabled"
            :clearable="item.clearable === false ? item.clearable : true"
            :filterable="item.filterable === false ? item.filterable : true"
            :placeholder="getPlaceholder(item)"
            v-bind="item.options"
            @change="handleEvent(item.emit, searchQuery[item.value])"
          >
            <el-option
              v-for="(childItem, childIndex) in listTypeInfoFn(item)"
              :key="childIndex"
              :label="childItem.key"
              :value="childItem.value"
            />
          </el-select>
          <!-- 时间选择框 -->
          <el-time-select
            v-if="item.type === 'time'"
            v-model="searchQuery[item.value]"
            :class="`filter-${item.type}`"
            :picker-options="item.TimePickerOptions"
            :clearable="item.clearable === false ? item.clearable : true"
            :disabled="item.disabled"
            :placeholder="getPlaceholder(item)"
            v-bind="item.options"
          />
          <!-- 日期选择框 -->
          <apex-date-picker
            v-if="item.type === 'date'"
            v-model="searchQuery[item.value]"
            :class="`filter-${item.type}`"
            :picker-options="item.datePickerOptions || datePickerOptions(item.disabledDate)"
            :type="item.dateType"
            :clearable="item.clearable === false ? item.clearable : true"
            :disabled="item.disabled"
            :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
            :placeholder="getPlaceholder(item)"
            v-bind="item.options"
          />
          <render-custom-component
            v-if="item.type === 'custom' && item.component && item.component.name"
            v-model="searchQuery[item.value]"
            :component-name="item.component.name"
            :props="item.component.props ? item.component.props : null"
          />
        </el-form-item>
        <div v-show="innerExpanded" class="fold-container">
          <el-form-item
            v-for="(item, index) in getFoldConfigList()"
            :key="index"
            :ref="item.value"
            :prop="item.value"
            :label="item.label"
            :label-width="item.labelWidth"
            :class="item.className"
          >
            <!-- 输入框 -->
            <el-input
              v-if="item.type === 'input'"
              v-model="searchQuery[item.value]"
              :class="`filter-${item.type}`"
              :type="item.type"
              :disabled="item.disabled"
              :clearable="item.clearable === false ? item.clearable : true"
              :placeholder="getPlaceholder(item)"
              v-bind="item.options"
              @keyup.enter.native="item.enter === false ? '' : search()"
            />
            <!-- 混合型输入框 -->
            <el-input
              v-if="item.type === 'mixin'"
              v-model="searchQuery[item.value]"
              :class="`filter-${item.type}`"
              :type="item.type"
              :disabled="item.disabled"
              :clearable="item.clearable === false ? item.clearable : true"
              :placeholder="getPlaceholder(item)"
              @keyup.enter.native="item.enter === false ? '' : search()"
            >
              <el-select
                slot="prepend"
                v-model="searchQuery[item.selectValue]"
                :clearable="item.selectClearable === false ? item.selectClearable : true"
                :placeholder="t('select.placeholder')"
                @change="handleEvent(item.emit, searchQuery[item.selectValue])"
              >
                <el-option
                  v-for="(childItem, childIndex) in listTypeInfoFn(item)"
                  :key="childIndex"
                  :label="childItem.key"
                  :value="childItem.value"
                />
              </el-select>
            </el-input>
            <!-- 选择框 -->
            <el-select
              v-if="item.type === 'select'"
              v-model="searchQuery[item.value]"
              :class="`filter-${item.type}`"
              :disabled="item.disabled"
              :clearable="item.clearable === false ? item.clearable : true"
              :filterable="item.filterable === false ? item.filterable : true"
              :placeholder="getPlaceholder(item)"
              v-bind="item.options"
              @change="handleEvent(item.emit, searchQuery[item.value])"
            >
              <el-option
                v-for="(childItem, childIndex) in listTypeInfoFn(item)"
                :key="childIndex"
                :label="childItem.key"
                :value="childItem.value"
              />
            </el-select>
            <!-- 时间选择框 -->
            <el-time-select
              v-if="item.type === 'time'"
              v-model="searchQuery[item.value]"
              :class="`filter-${item.type}`"
              :picker-options="item.TimePickerOptions"
              :clearable="item.clearable === false ? item.clearable : true"
              :disabled="item.disabled"
              :placeholder="getPlaceholder(item)"
              v-bind="item.options"
            />
            <!-- 日期选择框 -->
            <apex-date-picker
              v-if="item.type === 'date'"
              v-model="searchQuery[item.value]"
              :class="`filter-${item.type}`"
              :picker-options="item.datePickerOptions || datePickerOptions(item.disabledDate)"
              :type="item.dateType"
              :clearable="item.clearable === false ? item.clearable : true"
              :disabled="item.disabled"
              :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              :placeholder="getPlaceholder(item)"
              v-bind="item.options"
            />
            <render-custom-component
              v-if="item.type === 'custom' && item.component && item.component.name"
              v-model="searchQuery[item.value]"
              :component-name="item.component.name"
              :props="item.component.props ? item.component.props : null"
            />
          </el-form-item>
        </div>
        <div v-if="showExpand" class="expand-more-container">
          <img v-show="!innerExpanded" src="./img/down arrow.png" :title="t('tableFilter.expand')" @click="arrowClick(1)">
          <img v-show="innerExpanded" src="./img/up arrow.png" :title="t('tableFilter.packUp')" @click="arrowClick(2)">
        </div>
      </div>
      <div class="button-container">
        <el-button icon="el-icon-search" type="primary" style="margin-bottom: 10px" @click="search">{{
          t('common.search')
        }}</el-button>
        <el-button icon="el-icon-refresh" @click="reset">{{ t('common.reset') }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import locale from '@/mixins/index'
import _clone from 'lodash.clone'
import renderCustomComponent from './components/renderCustomComponent.vue'

export default {
  name: 'ApexFilter',
  components: {
    renderCustomComponent
  },
  mixins: [locale],
  props: {
    // 表单大小
    size: {
      type: String,
      default: 'small'
    },
    // label-width 宽度
    labelWidth: {
      type: String,
      default: 'auto'
    },
    // 自定义类名
    className: {
      type: String,
      default: ''
    },
    // 相关列表
    listTypeInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 过滤器列表
    filterList: {
      type: Array,
      default: () => []
    },
    // 参数
    query: {
      type: Object,
      default: () => { }
    },
    // 是否默认展开
    expandedAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flag: 'inner', // 内 inner  外outside
      searchQuery: {},
      cloningSearchQuery: {},
      innerExpanded: false
    }
  },
  computed: {
    showExpand() {
      return this.getFoldConfigList().length > 0
    }
  },
  watch: {
    searchQuery: {
      handler: function(val) {
        // 传入参数修改，不派发
        if (this.flag === 'outside') {
          this.flag = 'inner'
          return
        }
        // 修改传入进来的参数
        this.$emit('update:query', { ...this.query, ...val })
      },
      deep: true // 深度监听
    },
    query(val) {
      this.flag = 'outside' // 标识为传入参数修改
      this.searchQuery = val
    }
  },
  mounted() {
    this.initParams()
    this.initExpand()
  },
  methods: {
    // 初始化展开行
    initExpand() {
      if (this.showExpand) {
        this.innerExpanded = this.expandedAll
      }
    },
    getSize() {
      return this.size || (this.$ELEMENT || {}).size
    },
    initParams() {
      // 克隆一份初始数据 方便reset操作
      this.cloningSearchQuery = _clone(this.query)
      const obj = {}
      for (const key in this.query) {
        if (this.query[key]) {
          obj[key] = this.query[key]
        }
      }
      this.searchQuery = obj
    },
    // 获取列表
    getConfigList() {
      return this.filterList.filter(item => {
        // eslint-disable-next-line no-prototype-builtins
        return (!item.hasOwnProperty('show') || (item.hasOwnProperty('show') && item.show)) && !item.fold
      })
    },
    // 获取折叠列表
    getFoldConfigList() {
      return this.filterList.filter(item => {
        // eslint-disable-next-line no-prototype-builtins
        return (!item.hasOwnProperty('show') || (item.hasOwnProperty('show') && item.show)) && item.fold
      })
    },
    // 得到placeholder的显示
    getPlaceholder(row) {
      if (row.placeholder || row.placeholder === '') return row.placeholder
      let placeholder
      if (row.type === 'input' || row.type === 'textarea' || row.type === 'mixin') {
        placeholder = this.t('input.placeholder') + row.label
      } else if (row.type === 'select' || row.type === 'time' || row.type === 'date') {
        placeholder = this.t('select.placeholder') + row.label
      } else {
        placeholder = row.label
      }
      return placeholder
    },
    // 时间相关设置
    datePickerOptions(disabledDate) {
      if (disabledDate) {
        return {
          disabledDate(time) {
            // 大于当前的时间都不能选 (+十分钟让点击此刻的时候可以选择到当前时间)
            return time.getTime() > +new Date() + 1000 * 600 * 1
          }
        }
      } else {
        return {}
      }
    },
    // 点击展开收起按钮   type：1展开    2收起
    arrowClick(type) {
      this.innerExpanded = !this.innerExpanded
      this.$nextTick(() => {
        this.$emit('expandChange', this.innerExpanded)
      })
    },
    search() {
      this.$emit('search')
    },
    reset() {
      this.searchQuery = this.cloningSearchQuery
      this.$emit('reset')
    },
    // 派发的相关事件
    handleEvent(emit, value) {
      this.$emit(`${emit}`, value)
    },
    // 向外抛出获取组件内部query数据
    getQueryData() {
      return this.searchQuery
    },
    // 过滤select循环list
    listTypeInfoFn(data) {
      const list = data.list
      if (typeof list === 'function') {
        return list(data)
      }
      if (typeof list === 'string') {
        return this.listTypeInfo[list]
      }
      if (Array.isArray(list)) {
        return list
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.apex-filter {
  overflow: hidden;
  border: 1px solid #ccc;
  padding: 20px 0 10px 20px;
  position: relative;
  .btn-divider {
    position: absolute;
    height: calc(100% - 40px);
    width: 0px;
    border-left: 1px dashed #ccc;
    top: 20px;
    right: 129px;
  }
  /deep/ .el-form {
    display: flex;
    align-items: center;
    .el-form-item {
      margin: 0 30px 10px 0 !important;
      .el-form-item__label {
        font-size: 12px;
        padding-right: 8px;
      }
      .el-form-item__content {
        .el-input {
          font-size: 12px;
        }
      }
    }
  }
  .filter-input,
  .filter-time,
  .filter-date,
  .filter-select {
    width: 180px;
  }
  .filter-mixin {
    /deep/ .el-input-group__prepend {
      background-color: #fff;
      .el-select {
        width: 100px;
      }
    }
  }
  .form-container {
    float: left;
    width: calc(100% - 126px);
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    position: relative;
    .expand-more-container {
      position: absolute;
      bottom: 10px;
      right: 4px;
      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }
  .button-container {
    padding: 0 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: -10px;
    .el-button {
      margin: 0;
      font-size: 12px;
      width: 78px;
      height: 34px;
      padding: 0;
    }
  }
}
</style>
